import { formatISO, startOfDay } from 'date-fns';

const getISOStartOfDayDate = date => {
  return formatISO(startOfDay(date));
};

export default getISOStartOfDayDate;
